import { g, layers } from '@hcie/core';
import { EventBus } from '@hcie/shared';

type NamedDrawAction = {
    description: string;
    undo: () => void;
    redo: () => void;
};

export function makeNamedDrawAction(layerIndex: number, prev: ImageData, next: ImageData, desc: string): NamedDrawAction {
    // Note: We clone buffers to keep history immutable.
    const prevCopy = new ImageData(new Uint8ClampedArray(prev.data), prev.width, prev.height);
    const nextCopy = new ImageData(new Uint8ClampedArray(next.data), next.width, next.height);

    const apply = (img: ImageData) => {
        const layer = layers[layerIndex];
        if (!layer?.ctx) return;
        layer.ctx.putImageData(img, 0, 0);
        // Keep originalCanvas and UI in sync
        EventBus.emit('RENDER_LAYERS');
    };

    return {
        description: desc,
        undo: () => apply(prevCopy),
        redo: () => apply(nextCopy),
    };
}

export function bindDrawActionToWindow() {
    // Provide legacy global for canvas-ui FinishHandler.
    (window as any).makeNamedDrawAction = makeNamedDrawAction;
}

